import React, { useState, useEffect } from "react";
import Calender from "../../../assets/admin/images/whcalendar.svg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import Loader from "../../../layouts/loader/Loader";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import {
  status,
  totalPageCalculator,
  adsLIMIT,
  SingleFile,
} from "../../../utlis/common.utlis";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/admin/routes.utlis";
import Select from "react-select";
import { encode } from "base-64";

const Page = () => {
  const navigate = useNavigate();
  const [advertisement, setAdvertisement] = useState([]);
  const [categories, setCategory] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  const [tags, setTag] = useState([]);
  const [editTags, setEditTag] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    startDate: null,
    endDate: null,
    month: "",
    quarter: "",
    year: "",
  });
  const [dateType, setDateType] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedEditTag, setSelectedEditTag] = useState([]);
  const [selectedDelTag, setSelectedDelTag] = useState([]);
  const [imgError, setImgError] = useState({ status: false, msg: null });
  const [imgError1, setImgError1] = useState({ status: false, msg: null });
  const [startError, setStartError] = useState(false);
  const [endError, setEndError] = useState(false);
  const [tagError, setTagError] = useState(false);
  const [startEditError, setStartEditError] = useState(false);
  const [endEditError, setEndEditError] = useState(false);
  const [tagEditError, setTagEditError] = useState(false);
  const [file, setFile] = useState();
  const [editFile, setEditFile] = useState();
  const [addAd, setAddAd] = useState({ status: false });
  const [deleteAd, setDeleteAd] = useState({ status: false, id: null });
  const [editAd, setEditAd] = useState({
    status: false,
    id: null,
    title: null,
    description: null,
    service_type_id: null,
    category_id: null,
    start_date: null,
    end_date: null,
    image: null,
    tags: [],
  });
  const options = [];
  const editOptions = [];

  const initialValues = {
    title: "",
    description: "",
    service_type_id: "",
    start_date: "",
    end_date: "",
    image: "",
    tags: "",
  };

  const initialEditValues = {
    title: editAd.title,
    description: editAd.description,
    service_type_id: editAd.service_type_id,
    start_date: "",
    end_date: "",
    image: "",
    tags: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string()
      .required("Description is required!")
      .min(8, "Description must be 8 characters long."),
    service_type_id: Yup.number().required("Select category is required!"),
  });

  const getAdvertisementList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all advertisement list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setAdvertisement(response.data.data.advertisementList);
      setTotal(response.data.data.total);
    } else setAdvertisement([]);
    setLoading(false);
  };

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const getSubCategoryList = async (id) => {
    const response = await ApiService.getAPIWithAccessToken(
      api.categoryList + `?categoryid=${id}`
    );
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setSubCategory(response?.data?.data?.categories);
    } else setSubCategory([]);
  };

  const getTagsList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      response.data.data.tags.forEach((element) => {
        options.push({ value: element.id, label: element.name });
      });
      setTag(options);
    } else options = [];
  };


  const updateAds = async (formValue) => {
    if (
      editAd.start_date === "" ||
      editAd.start_date === null ||
      !editAd.start_date
    ) {
      setStartEditError(true);
      return;
    } else setStartEditError(false);
    if (
      editAd.end_date === "" ||
      editAd.end_date === null ||
      !editAd.end_date
    ) {
      setEndEditError(true);
      return;
    } else setEndEditError(false);
    if (imgError1.status) {
      setImgError1({ status: true, msg: imgError1.msg });
      return;
    } else setImgError1({ status: false, msg: null });
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    form.append("service_type_id", formValue.service_type_id);
    form.append("image", editFile);
    form.append("start_date", moment(editAd.start_date).format("yyyy-MM-DD"));
    form.append("end_date", moment(editAd.end_date).format("yyyy-MM-DD"));
    selectedEditTag.forEach((ele) => {
      form.append("tags[]", ele.value);
    });
    selectedDelTag.forEach((ele) => {
      form.append("deletetageid[]", ele.value);
    });
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.updateAdvertisement + editAd.id,
      form
    );
    setEditAd({
      status: false,
      id: null,
      title: null,
      description: null,
      service_type_id: null,
      category_id: null,
      start_date: null,
      end_date: null,
      image: null,
      tags: [],
    });
    setEditFile("");
    setSelectedEditTag([]);
    setSelectedDelTag([]);
    setSubCategory([]);
    if (response.data.status) {
      toast.success(response.data.message);
      getAdvertisementList(
        api.advertisement + `?page=${pageNum}&limit=${adsLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const addAds = async (formValue) => {
    if (selectedTag.length === 0) {
      setTagError(true);
      return;
    } else setTagError(false);
    if (startDate === "" || startDate === null || !startDate) {
      setStartError(true);
      return;
    } else setStartError(false);
    if (endDate === "" || endDate === null || !endDate) {
      setEndError(true);
      return;
    } else setEndError(false);
    if (file === "" || file === null || !file) {
      setImgError({ status: true, msg: `File not found.` });
      return;
    } else setImgError({ status: false, msg: null });
    setLoading(true);
    let form = new FormData();
    form.append("title", formValue.title);
    form.append("description", formValue.description);
    form.append("service_type_id", formValue.service_type_id);
    form.append("image", file);
    form.append("start_date", moment(startDate).format("yyyy-MM-DD"));
    form.append("end_date", moment(endDate).format("yyyy-MM-DD"));
    selectedTag.forEach((ele) => {
      form.append("tags[]", ele.value);
    });
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.addAdvertisement,
      form
    );
    setAddAd({ status: false });
    setFile("");
    setStartDate("");
    setEndDate("");
    setSelectedTag([]);
    setSubCategory([]);
    if (response.data.status) {
      toast.success(response.data.message);
      getAdvertisementList(
        api.advertisement + `?page=${pageNum}&limit=${adsLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteAdFunc = async (id) => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.deleteAdvertisement + `${id}`
    );
    setDeleteAd({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getAdvertisementList(
        api.advertisement + `?page=${pageNum}&limit=${adsLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const adsDetails = async (id) => {
    const response = await ApiService.getAPIWithAccessToken(
      api.advertisementDetail + `${id}`
    );
    if (response.data.status) {
      let details = response.data.data;
      getSubCategoryList(details.category_id);
      setEditAd({
        status: true,
        id: details.id,
        title: details.title,
        description: details.description,
        service_type_id: details.service_type_id,
        category_id: details.category_id,
        start_date: details.start_date,
        end_date: details.end_date,
        image: details.image,
        tags: details.tags,
      });
      details.tags.forEach((element) => {
        editOptions.push({
          value: element.id,
          label: element.name,
        });
      });
      setEditTag(editOptions);
    }
  };

  const handleTag = (arr) => {
    const deleteTags = editTags.filter(
      ({ value: id1 }) => !arr.some(({ value: id2 }) => id2 === id1)
    );
    setSelectedDelTag(deleteTags);
    const tags = arr.filter(
      ({ value: id1 }) => !editTags.some(({ value: id2 }) => id2 === id1)
    );
    setSelectedEditTag(tags);
  };

  const handleImgChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      const maxFileSize = SingleFile;
      if (fileSizeInMB > maxFileSize) {
        setFile();
        setImgError({
          status: true,
          msg: `File size limit exceeds ${maxFileSize} MB. Your file size is ${fileSizeInMB.toFixed(
            2
          )} MB.`,
        });
      } else {
        setFile(e.target.files[0]);
        setImgError({ status: false, msg: null });
      }
    } else {
      setImgError({ status: true, msg: `File not found.` });
    }
  };

  const handleEditImgChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      const maxFileSize = SingleFile;
      if (fileSizeInMB > maxFileSize) {
        setEditFile();
        setImgError1({
          status: true,
          msg: `File size limit exceeds ${maxFileSize} MB. Your file size is ${fileSizeInMB.toFixed(
            2
          )} MB.`,
        });
      } else {
        setEditFile(e.target.files[0]);
        setImgError1({ status: false, msg: null });
      }
    } else {
      setImgError1({ status: true, msg: `File not found.` });
    }
  };


  const handleFilterChange = (e, date = null) => {
    const { name, value } = e.target || {};
    const formattedDate = date ? moment(date).format("yyyy-MM-DD") : null;

    // Update the filters state
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [name]: date === null ? null : formattedDate || value, // Handle null for cleared dates
      };
      return updatedFilters;
    });
  };

  // Trigger search with current filters
  const handleSearch = () => {
    fetchFilteredData(filters);
  };

  // Reset all filters to initial state
  const handleReset = () => {
    const resetFilters = {
      name: "",
      status: "",
      category: "",
      type: "",
      state_id: "",
      startDate: null,
      endDate: null,
      month: "",
      quarter: "",
      year: "",
    };

    setFilters(resetFilters);
    setDateType("");
    setPageNum(1);

    fetchFilteredData(resetFilters);
  };

  const fetchFilteredData = async (filterParams) => {
    const query = new URLSearchParams({
      page: pageNum,
      limit: adsLIMIT,
      search: filterParams.name,
      startDate: filterParams.startDate,
      endDate: filterParams.endDate,
      month: filterParams.month,
      quarter: filterParams.quarter,
      year: filterParams.year,
    }).toString();

    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(`${api.advertisement}?${query}`);
    if (response.data.status && response.data.statusCode === 200) {
      setAdvertisement(response.data.data.advertisementList);
      setTotal(response.data.data.total);
    } else {
      setAdvertisement([]);
    }
    setLoading(false);
  };

  const handleDateTypeChange = (e) => {
    const value = e.target.value;

    // Clear all other date-related fields when selecting a new date_type
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: null,
      endDate: null,
      month: value === "month" ? prevFilters.month : "",
      quarter: value === "quarter" ? prevFilters.quarter : "",
      year: value === "year" || value === "month" || value === "quarter" ? prevFilters.year : "",
    }));

    setDateType(value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const query = new URLSearchParams({
        page: pageNum,
        limit: adsLIMIT,
        /* search: filters.name,
        startDate: filters.startDate,
        endDate: filters.endDate,
        month: filters.month,
        quarter: filters.quarter,
        year: filters.year, */
      }).toString();

      setLoading(true);
      const response = await ApiService.getAPIWithAccessToken(`${api.advertisement}?${query}`);
      if (response.data.status && response.data.statusCode === 200) {
        setAdvertisement(response.data.data.advertisementList);
        setTotal(response.data.data.total);
      } else {
        setAdvertisement([]);
      }
      setLoading(false);
    };

    fetchData();
    getCategoryList(api.categoryList);
    getTagsList(api.tagsList);

  }, [pageNum]);


  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h3 className="heading-title">Manage Advertisement</h3>
          <div className="cc-search-filter wd50">
            <div className="row g-2">

              <div className="col-md-6">

              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <button
                    style={{ width: "100%" }}
                    type="button"
                    className="btn-gr"
                    onClick={() => setAddAd({ status: true })}
                  >
                    Add New Advertisement
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="care-title-header">
          <div className="cc-search-filter wd100 mt-2">
            <div className="row g-2">
              <div className="col-md-3">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={handleFilterChange}
                    value={filters.name || ""}
                  />
                  <span className="search-icon">
                    <i className="cc-input-group-text  mdi mdi-magnify"></i>
                  </span>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="date_type"
                    onChange={handleDateTypeChange}
                    value={dateType || ""}
                  >
                    <option value="">Choose Date Range</option>
                    <option value="date">Date</option>
                    <option value="month">Month</option>
                    <option value="quarter">Quarter</option>
                    <option value="year">Year</option>
                  </select>
                </div>
              </div>

              {/* Conditionally Render Fields Based on Date Type */}
              {dateType === "date" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      {/* From Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.startDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "startDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="From Date"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      {/* To Date */}
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={filters.endDate}
                        onChange={(date) =>
                          handleFilterChange({ target: { name: "endDate" } }, date)
                        }
                        className="DatePicker-control"
                        isClearable
                        autoComplete="off"
                        placeholderText="To Date"
                      />
                    </div>
                  </div>
                </>
              )}

              {dateType === "month" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="month"
                        onChange={handleFilterChange}
                        value={filters.month || ""}
                      >
                        <option value="">Select Month</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                        <option value="3">March</option>
                        <option value="4">April</option>
                        <option value="5">May</option>
                        <option value="6">June</option>
                        <option value="7">July</option>
                        <option value="8">August</option>
                        <option value="9">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={handleFilterChange}
                        value={filters.year || ""}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "quarter" && (
                <>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="quarter"
                        onChange={(e) => handleFilterChange(e)}
                        value={filters.quarter || ""}
                      >
                        <option value="">All Quarters</option>
                        <option value="1">Q1 (Jan - Mar)</option>
                        <option value="2">Q2 (Apr - Jun)</option>
                        <option value="3">Q3 (Jul - Sep)</option>
                        <option value="4">Q4 (Oct - Dec)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="year"
                        onChange={(e) => handleFilterChange(e)}
                        value={filters.year || ""}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 10 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </>
              )}

              {dateType === "year" && (
                <div className="col-md-2">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="year"
                      onChange={(e) => handleFilterChange(e)}
                      value={filters.year || ""}
                    >
                      <option value="">Select Year</option>
                      {Array.from({ length: 10 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              )}

              <div className="col-md-2">
                <div className="form-group">
                  <button
                    className="btn btn-gr p-1"
                    onClick={handleSearch}
                  >
                    <i className="cc-input-group-text mdi mdi-magnify"></i>
                  </button> &nbsp;
                  <button
                    className="btn btn-re p-1"
                    onClick={handleReset}
                  >
                    <i className="cc-input-group-text mdi mdi-restore"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="care-content-card">
          <div className="row mt-4 ">
            {advertisement.length !== 0 ? (
              advertisement.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-12 mb-3">
                    <div className="advertisement-card">
                      <div className="care-card-head">
                        <div className="care-id">{ele.title ?? "NA"}</div>
                        <div>
                          <Link
                            className="btn-gr"
                            to=""
                            onClick={() => adsDetails(ele.id)}
                          >
                            Edit
                          </Link>
                          <Link
                            className="btn-re mx-2"
                            to=""
                            onClick={() =>
                              setDeleteAd({ status: true, id: ele.id })
                            }
                          >
                            Delete
                          </Link>
                          <Link
                            className="btn-bl"
                            to=""
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.advertisementDetails, {
                                state: {
                                  id: encode(ele.id),
                                },
                              });
                            }}
                          >
                            View Detail
                          </Link>
                        </div>
                      </div>
                      <div className=" d-flex align-items-center px-3">
                        <div className="advertisement-image">
                          {ele.image === null ||
                            ele.image === "" ||
                            ele.image === undefined ? (
                            <img
                              src={NoImage}
                              alt=""
                              height={100}
                              width={100}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          ) : (
                            <img
                              src={ele.image}
                              alt=""
                              height={100}
                              width={100}
                              style={{
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          )}
                        </div>
                        <div className="advertisement-content w-100">
                          <div className="d-flex justify-content-between">
                            <div className="care-status">
                              Ad Id: <span>{ele.id}</span>
                            </div>

                            <div className="care-status">
                              Status: <span>{ele.Ads_status}</span>
                            </div>
                          </div>
                          <div className="pointtags-list mb-1">
                            <div className="tags-item">
                              {ele.category ?? "NA"}
                            </div>
                            <div className="tags-item-sub">
                              {ele.subcategory ?? "NA"}
                            </div>
                          </div>
                          <div className="date-text mb-1">
                            <img src={WhCalen} alt="" />{" "}
                            {moment(ele.created_date).format(
                              "MM-DD-yyyy hh:mm A"
                            )}
                          </div>
                          <p className="mb-3">{ele.description ?? "NA"}</p>
                        </div>
                      </div>
                      <div className="care-card-foot">
                        <div className="care-user-info">
                          <div className="care-user-image">
                            {ele?.user?.image === null ||
                              ele?.user?.image === "" ||
                              ele?.user?.image === undefined ? (
                              <img
                                src={NoImage}
                                alt=""
                                height={40}
                                width={40}
                                style={{
                                  objectFit: "cover",
                                  objectPosition: "center",
                                }}
                              />
                            ) : (
                              <img
                                src={ele?.user?.image}
                                alt=""
                                height={40}
                                width={40}
                                style={{
                                  objectFit: "cover",
                                  objectPosition: "center",
                                }}
                              />
                            )}
                          </div>
                          <div className="care-user-text ms-2">
                            <div className="care-user-name text-capitalize mb-0 pb-0">
                              {ele?.user?.fullname ?? "NA"}
                            </div>
                            <div className="Confirmed-Provider text-lowercase">
                              {ele?.user?.email ?? "NA"}
                            </div>
                          </div>
                        </div>
                        <div className="care-action1">
                          {ele?.user?.user_type === null ||
                            ele?.user?.user_type === undefined ||
                            ele?.user?.user_type === "" ? null : ele?.user
                              ?.user_type == 4 ? null : ele?.user?.user_type ==
                                2 ? (
                            <Link
                              className="btn-gra"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.providerDetails, {
                                  state: {
                                    id: encode(ele?.user?.provider_id),
                                  },
                                });
                              }}
                            >
                              View Profile
                            </Link>
                          ) : (
                            <Link className="btn-bl" to="">
                              View Profile
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3">
            {advertisement.length !== 0 ? (
              <div className="care-table-pagination">
                <ul className="care-pagination">
                  {pageNum !== 1 && (
                    <li
                      className="disabled"
                      id="example_previous"
                      onClick={() => setPageNum(pageNum - 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="0"
                        tabIndex="0"
                        className="page-link"
                      >
                        Previous
                      </Link>
                    </li>
                  )}

                  {totalPageCalculator(total, adsLIMIT).length === 1
                    ? null
                    : totalPageCalculator(total, adsLIMIT).map(
                      (pageNo, indx) => {
                        return (
                          <li
                            className={pageNo === pageNum ? "active" : ""}
                            key={indx}
                            onClick={() => setPageNum(pageNo)}
                          >
                            <Link to="" className="page-link">
                              {pageNo}
                            </Link>
                          </li>
                        );
                      }
                    )}

                  {pageNum !== Math.ceil(total / adsLIMIT) && (
                    <li
                      className="next"
                      id="example_next"
                      onClick={() => setPageNum(pageNum + 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="7"
                        tabIndex="0"
                        className="page-link"
                      >
                        Next
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        show={editAd.status}
        onHide={() => {
          setEditAd({
            status: false,
            id: null,
            title: null,
            description: null,
            service_type_id: null,
            category_id: null,
            start_date: null,
            end_date: null,
            image: null,
            tags: [],
          });
          setStartError(false);
          setEndError(false);
          setTagError(false);
          setSubCategory([]);
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Advertisement</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={updateAds}
              >
                <Form className="findcare-form">
                  <div className="form-group">
                    <h4>Title</h4>
                    <Field
                      type="text"
                      className="form-control todo-list-input"
                      name="title"
                      placeholder="Enter Title"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  {/* <div className="form-group">
                    <Field
                      type="number"
                      className="form-control todo-list-input"
                      name="offer_perc"
                      placeholder="Enter Offer Percentage"
                    />
                    <ErrorMessage
                      name="offer_perc"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div> */}
                  <div className="form-group">
                    <h4>Category</h4>
                    <select
                      className="form-control todo-list-input"
                      name="category"
                      onChange={(e) => getSubCategoryList(e.target.value)}
                      defaultValue={editAd.category_id}
                    >
                      <option value="">Select Category</option>
                      {categories.length !== 0
                        ? categories.map((ele, indx) => {
                          return (
                            <option key={indx} value={ele.id}>
                              {ele.name ?? "NA"}
                            </option>
                          );
                        })
                        : null}
                    </select>
                  </div>
                  <div className="form-group">
                    <h4>Sub Category</h4>
                    <Field
                      as="select"
                      type="text"
                      className="form-control todo-list-input"
                      name="service_type_id"
                    >
                      <option value="">Select Sub Category</option>
                      {subCategories.length !== 0
                        ? subCategories.map((ele, indx) => {
                          return (
                            <option key={indx} value={ele.id}>
                              {ele.name}
                            </option>
                          );
                        })
                        : null}
                    </Field>
                    <ErrorMessage
                      name="service_type_id"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Tags</h4>
                    <Select
                      name="tags"
                      className="form-control todo-list-input"
                      isMulti={true}
                      defaultValue={editTags}
                      options={tags}
                      onChange={(ans) => {
                        handleTag(ans);
                      }}
                    />
                    {tagEditError && (
                      <div className="alert alert-danger">
                        Tags is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Start Date</h4>
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={editAd.start_date}
                      className="form-control todo-list-input"
                      onChange={(date) => {
                        setEditAd((prevState) => ({
                          ...prevState,
                          start_date: date,
                        }));
                      }}
                      isClearable
                      name="start_date"
                      autoComplete="off"
                      placeholderText="Select Start Date"
                    />
                    {startEditError && (
                      <div className="alert alert-danger">
                        Start date is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>End Date</h4>
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={editAd.end_date}
                      className="form-control todo-list-input"
                      onChange={(date) => {
                        setEditAd((prevState) => ({
                          ...prevState,
                          end_date: date,
                        }));
                      }}
                      isClearable
                      name="end_date"
                      autoComplete="off"
                      placeholderText="Select End Date"
                    />
                    {endEditError && (
                      <div className="alert alert-danger">
                        End date is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Upload Image</h4>
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleEditImgChange}
                      className="form-control todo-list-input"
                    />
                    {imgError1.status && (
                      <div className="alert alert-danger">
                        {imgError1.msg ?? null}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Description</h4>
                    <Field
                      as="textarea"
                      className="form-control todo-list-input"
                      name="description"
                      placeholder="Enter Description"
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group text-end">
                    <button
                      type="button"
                      onClick={() => {
                        {
                          setEditAd({
                            status: false,
                            id: null,
                            title: null,
                            description: null,
                            service_type_id: null,
                            category_id: null,
                            start_date: null,
                            end_date: null,
                            image: null,
                            tags: [],
                          });
                          setStartError(false);
                          setEndError(false);
                          setTagError(false);
                          setSubCategory([]);
                        }
                      }}
                      className="btn-re me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-gr me-2"
                      data-bs-dismiss="modal"
                    >
                      Update
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={addAd.status}
        onHide={() => {
          setAddAd({
            status: false,
          });
          setImgError(false);
          setStartError(false);
          setEndError(false);
          setTagError(false);
          setSubCategory([]);
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add New Advertisement</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={addAds}
              >
                <Form className="findcare-form">
                  <div className="form-group">
                    <h4>Title</h4>
                    <Field
                      type="text"
                      className="form-control todo-list-input"
                      name="title"
                      placeholder="Enter Title"
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  {/* <div className="form-group">
                    <Field
                      type="number"
                      className="form-control todo-list-input"
                      name="offer_perc"
                      placeholder="Enter Offer Percentage"
                    />
                    <ErrorMessage
                      name="offer_perc"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div> */}
                  <div className="form-group">
                    <h4>Category</h4>
                    <select
                      className="form-control todo-list-input"
                      name="category"
                      onChange={(e) => getSubCategoryList(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {categories.length !== 0
                        ? categories.map((ele, indx) => {
                          return (
                            <option key={indx} value={ele.id}>
                              {ele.name ?? "NA"}
                            </option>
                          );
                        })
                        : null}
                    </select>
                  </div>
                  <div className="form-group">
                    <h4>Sub Category</h4>
                    <Field
                      as="select"
                      type="text"
                      className="form-control todo-list-input"
                      name="service_type_id"
                    >
                      <option value="">Select Sub Category</option>
                      {subCategories.length !== 0
                        ? subCategories.map((ele, indx) => {
                          return (
                            <option key={indx} value={ele.id}>
                              {ele.name}
                            </option>
                          );
                        })
                        : null}
                    </Field>
                    <ErrorMessage
                      name="service_type_id"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group">
                    <h4>Tags</h4>
                    <Select
                      name="tags"
                      className="form-control todo-list-input"
                      isMulti={true}
                      options={tags}
                      onChange={(ans) => {
                        setSelectedTag(ans);
                      }}
                    />
                    {tagError && (
                      <div className="alert alert-danger">
                        Tags is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Start Date</h4>
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={startDate}
                      className="form-control todo-list-input"
                      onChange={(date) => {
                        setStartDate(date);
                      }}
                      isClearable
                      name="start_date"
                      autoComplete="off"
                      placeholderText="Select Start Date"
                    />
                    {startError && (
                      <div className="alert alert-danger">
                        Start date is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>End Date</h4>
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={endDate}
                      className="form-control todo-list-input"
                      onChange={(date) => {
                        setEndDate(date);
                      }}
                      isClearable
                      name="end_date"
                      autoComplete="off"
                      placeholderText="Select End Date"
                    />
                    {endError && (
                      <div className="alert alert-danger">
                        End date is required!
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Upload Image</h4>
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleImgChange}
                      className="form-control todo-list-input"
                    />
                    {imgError.status && (
                      <div className="alert alert-danger">
                        {imgError.msg ?? null}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <h4>Description</h4>
                    <Field
                      as="textarea"
                      className="form-control todo-list-input"
                      name="description"
                      placeholder="Enter Description"
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                  <div className="form-group text-end">
                    <button
                      type="button"
                      onClick={() => {
                        {
                          setAddAd({
                            status: false,
                          });
                          setImgError(false);
                          setStartError(false);
                          setEndError(false);
                          setTagError(false);
                          setSubCategory([]);
                        }
                      }}
                      className="btn-re me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-gr"
                      data-bs-dismiss="modal"
                    >
                      Add
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteAd.status}
        onHide={() => {
          setDeleteAd({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} alt="" />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Advertisement</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete your
                  advertisement ?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteAd({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                  onClick={() => deleteAdFunc(deleteAd.id)}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
